var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.handleBlur)?_c('v-container',{ref:"market",attrs:{"fluid":""}},[_c('the-markets-info')],1):_c('v-container',{ref:"market",attrs:{"fluid":""}},[_c('img',{attrs:{"src":require("../assets/blur_imgs/blur3.png"),"alt":_vm.$t('extras.blurredImageLockedMarketsAlt')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }